import React from 'react';
import _ from 'lodash';
import { ERROR_WRONG_INFORMATIONS, ERROR_ADD_DEEPLINK, SUCCESS_UPDATE_TEXT, ERROR_GETTING_DEEPlINKS_ANALYTICS, BRANCH_EVENTS, ANALYTICS_TYPES, ANALYTICS } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { addNewDeepLink, getDeepLinksAnalytics } from '../../apis/backend';
import { showNotification } from '../Notification/Notification.view';
import moment from 'moment';
import { formattedValue } from '../../utils/tools';
import { getDeepLinks } from '../../apis/backend';
type DeepLink = {
    campaign: string;
    channel: string;
    deeplinkUrl: string;
    summary: any;
    rows: any;
    creationDate: Date;
};
type DeepLinks = Record<string, DeepLink>;
export const getAllDeeplinks = async (setIsLoading, setExpandedDeepLinks) => {
    setIsLoading(true);
    setExpandedDeepLinks({})
    const deeplinks = await getDeepLinks();
    const sortedDeepLinks = _.keys(deeplinks)
        .sort((a, b) => moment(deeplinks[b].creationDate).valueOf() - moment(deeplinks[a].creationDate).valueOf())
        .reduce((obj, cur) => ({ ...obj, [cur]: deeplinks[cur] }), {});
    setIsLoading(false);
    return sortedDeepLinks;
}
export const handleToggle = async (
    setExpandedDeepLinks: React.Dispatch<React.SetStateAction<any>>,
    id: string,
    deepLinks: DeepLinks,
    startDate: Date,
    endDate: Date,
    setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>,
    setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    setOpenedDeepLinks: React.Dispatch<React.SetStateAction<any>>,
    deepLinksAnalytics: any,
    setDateModified
): Promise<void> => {
    const { campaign, channel, creationDate } = deepLinks[id];
    setDateModified(false)
    setExpandedDeepLinks((prevState: Record<string, boolean>) => ({
        ...prevState,
        [id]: !prevState[id]
    }));
    setOpenedDeepLinks((prevState) => ({
        ...prevState,
        [id]: !prevState[id] ? deepLinks[id] : undefined
    }));
    if (!deepLinksAnalytics || !_.keys(deepLinksAnalytics).includes(id)) {
        await getAnalytics(
            id,
            campaign,
            channel,
            startDate,
            endDate,
            setIsLoadingAnalytics,
            setDeepLinksAnalytics,
            openErrorModal,
            creationDate
        );
    }
    if (id in deepLinksAnalytics) {
        const { [id]: _, ...updatedDeepLinksAnalytics } = deepLinksAnalytics;
        setDeepLinksAnalytics(updatedDeepLinksAnalytics);
    }
};

export const copyLink = (link: string): void => {
    navigator.clipboard.writeText(link);
};

export const handleChangeTypes = (
    event: React.ChangeEvent<HTMLInputElement>,
    setChannel: React.Dispatch<React.SetStateAction<any>>
): void => {
    const { value } = event.target;
    setChannel(value);
};


export const addDeepLink = async (
    campaign: string,
    channel: string,
    setIsLoading: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    setIsOpen: React.Dispatch<React.SetStateAction<any>>,
    setChannel: React.Dispatch<React.SetStateAction<any>>,
    setCampaign: React.Dispatch<React.SetStateAction<any>>,
    setIsAddDeepLink: React.Dispatch<React.SetStateAction<any>>,
    setIsAddLoading
): Promise<void> => {
    try {
        if (campaign && channel) {
            setIsAddLoading(true)
            await addNewDeepLink(campaign, channel);
            closeModal(setIsOpen, setChannel, setCampaign);
            setIsLoading(false);
            showNotification(
                'light',
                'ltr',
                'primary',
                SUCCESS_UPDATE_TEXT,
                `Ce lien magique a bien été ajouté`
            );
            setIsAddDeepLink(true);
        } else {
            openErrorModal(ERROR_WRONG_INFORMATIONS);
        }
    } catch (error) {
        sendCloudWatchAlert(`Error adding deep link: ${error}`);
        openErrorModal(ERROR_ADD_DEEPLINK);
    }
    setIsAddLoading(false)
    setIsLoading(false);
};

export const closeModal = (
    setIsOpen: React.Dispatch<React.SetStateAction<any>>,
    setChannel: React.Dispatch<React.SetStateAction<any>>,
    setCampaign: React.Dispatch<React.SetStateAction<any>>
): void => {
    setIsOpen(false);
    setChannel('');
    setCampaign('');
};
export const getChartData = (deepLinkAnalytic, isFirstChart) => {
    const createDataItem = (eventType, countPath, name, extraFields = {}) => {
        const count = countPath?.reduce((acc, key) => acc?.[key], deepLinkAnalytic) || 0;
        return { eventType, count, name, ...extraFields };
    };
    const getPercentage = (element) => deepLinkAnalytic?.rows?.newInstallations?.rates?.[element] || null;
    const dataSets = {
        dataForPurchase: [
            createDataItem('newInstallations', ['rows', 'newInstallations', 'purchases'], 'Nouveaux utilisateurs', {
                description: "N'avaient pas l'application",
            }),
            createDataItem('existingAppUsersWithSignups', ['rows', 'existingAppUsersWithSignups', 'purchases'], 'Nouveaux inscrits', {
                description: "Avaient déjà l'application, mais pas de compte",
            }),
            createDataItem('existingUsersWithPurchasesWithoutInstall', ['rows', 'existingUsersWithPurchasesWithoutInstall', 'purchases'], 'Anciens utilisateurs', {
                description: "Avaient l'application et un compte",
            }),
        ],
        dataForRegistration: [
            createDataItem('newInstallations', ['rows', 'newInstallations', 'signups'], 'Nouveaux utilisateurs', {
                description: "N'avaient pas l'application",
            }),
            createDataItem('existingAppUsersWithSignups', ['rows', 'existingAppUsersWithSignups', 'signups'], 'Nouveaux inscrits', {
                description: "Avaient déjà l'application, mais pas de compte",
            }),
        ],
        dataForNewUsers: [
            createDataItem('newAppInstallationUsersClicks', ['summary', 'newAppInstallationUsersClicks'], ANALYTICS.newAppInstallationUsersClicks),
            createDataItem('installs', ['rows', 'newInstallations', 'installs'], ANALYTICS.installs, {
                percent: getPercentage('installs'),
            }),
            createDataItem('signups', ['rows', 'newInstallations', 'signups'], ANALYTICS.signups, {
                percent: getPercentage('signups'),
            }),
            createDataItem('purchases', ['rows', 'newInstallations', 'purchases'], ANALYTICS.purchases, {
                percent: getPercentage('purchases'),
            }),
        ],
        dataForNewsletterChart: [
            createDataItem(BRANCH_EVENTS.REGISTRATION, ['summary', 'totalSignUps'], ANALYTICS.complete_registration),
            createDataItem('totalNewsletterSubscribers', ['summary', 'totalNewsletterSubscribers'], ANALYTICS.totalNewsletterSubscribers),
        ],
    };
    return {
        pieData: isFirstChart ? dataSets.dataForPurchase : dataSets.dataForRegistration,
        chartData: isFirstChart ? dataSets.dataForNewUsers : dataSets.dataForNewsletterChart,
    };
};

export const onSelectDate = async (
    ranges: any,
    setDateRange: React.Dispatch<React.SetStateAction<any>>,
    ids: any,
    setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>,
    setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: React.Dispatch<React.SetStateAction<any>>,
    deepLinks: any,
    setDateModified
) => {
    setDateModified(true);
    for (const id of ids) {
        const { campaign, channel, creationDate } = deepLinks[id];
        try {
            await getAnalytics(
                id,
                campaign,
                channel,
                ranges.startDate,
                ranges.endDate,
                setIsLoadingAnalytics,
                setDeepLinksAnalytics,
                openErrorModal,
                creationDate
            );
        } catch (error) {
            console.error(`Error processing ID ${id}:`, error);
        }
    }
    setDateRange(ranges);
};



export const getAnalytics = async (
    id: string,
    campaign: string,
    channel: string,
    startDate: Date,
    endDate: Date,
    setIsLoadingAnalytics: React.Dispatch<React.SetStateAction<any>>,
    setDeepLinksAnalytics: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    creationDate: Date
): Promise<void> => {
    try {
        setIsLoadingAnalytics((prev) => ({ ...prev, [id]: true }));
        const deepLinkCreationDate = moment(creationDate).toISOString().split('.')[0];
        const deepLinkStartDate = moment(startDate).toISOString().split('.')[0];
        const deepLinkAnalytics = await getDeepLinksAnalytics(campaign, channel, startDate, endDate, deepLinkCreationDate === deepLinkStartDate);
        if (deepLinkAnalytics) {
            setDeepLinksAnalytics((prev) => ({
                ...prev,
                [id]: deepLinkAnalytics?.deeplinks[0],
            }));
            setIsLoadingAnalytics((prev) => ({ ...prev, [id]: false }));

        }

    } catch (error) {
        sendCloudWatchAlert(`Error getting deep link analytics: ${error}`);
        openErrorModal(ERROR_GETTING_DEEPlINKS_ANALYTICS);
        setIsLoadingAnalytics((prev) => ({ ...prev, [id]: false }));
    }
};

export const calculateConversionRate = (analytics) => {
    const installRate = analytics?.summary?.conversionRates?.installRate || 0;
    const signupRate = analytics?.summary?.conversionRates?.signupRate || 0;
    const purchaseRate = analytics?.summary?.conversionRates?.purchaseRate || 0;

    return formattedValue(installRate * signupRate * purchaseRate * 100);
};